module.exports = __webpack_public_path__ + "static/media/USGoldCurrencyLLC-UserAgreementDec12019.9c998d12.pdf";